export default {
  setLanguage({ commit }, lang) {
    commit("setLanguage", lang);
  },
  setTechAccess({ commit }, toggle) {
    commit("setTechAccess", toggle);
  },
  setAccessMode({ commit }, mode) {
    commit("setAccessMode", mode);
  },
  setLoading({ commit }, toggle) {
    commit("setLoading", toggle);
  }
};
